
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Tooltip,
    Menu,
    MenuItem,
    Divider,
    ListItemIcon,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import MenuIcon from "@mui/icons-material/Menu";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import Person from "@mui/icons-material/Person";
import {useTheme} from '@mui/material/styles';
import {GlobalSearchFieldComponent} from "./GlobalSearchField"
import {useAuth} from "../../hooks/useAuth";
import {useUser} from "../../hooks/useUser";
//import LogoNC from "../../resources/logo_nc.svg";
import LogoNC from "../../resources/logo_nc_black.png";
import LogoNC2 from "../../resources/logo_nc_v02-black.png";
import {useSnackbar} from "notistack";
import {UserAvatar} from "../icons/UserAvatar";

export const HeaderComponent = () => {

  const styles = ContainerClasses();

  //for now, logo is hardcoded
  const Logo = LogoNC2;

  const { onLogout } = useAuth();
  const { userProfile } = useUser();

  const theme = useTheme();

  const { enqueueSnackbar } = useSnackbar();

  const searchFieldContainer = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }

  const [anchorElMenu, setAnchorElMenu] = React.useState<null | HTMLElement>(null);

  const handleOpenAccoutMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  }

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };

  const handleLogout = () => {
    setAnchorElMenu(null);
    onLogout();
  }


/*
  const menuElement = (listView: ListViewModel) => {

    return (
      <MenuItem
         key={listView.Uuid_sys}
         onClick={() => {setAnchorElMenu(null);
                         selectList(listView);}}
      >
         <Typography
            sx={{ textAlign: 'center' }}
         >
           {listView.Label_sys}
         </Typography>
      </MenuItem>
    )
  }
*/
  const ITEM_HEIGHT=48;


  return (
     <Toolbar sx={styles.containerRowB}>
        <Box sx={styles.containerLogo}>
          <img
            style={{width: 150}}
            alt="logo"
            src={Logo}
          />
        </Box>


        <GlobalSearchFieldComponent/>


        <Box>
          <Tooltip title="Account">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={handleOpenAccoutMenu}
            >
              <UserAvatar
                userProfile={userProfile}
                size={30}
              />
            </IconButton>

          </Tooltip>

           <Menu
             id="account-menu"
             anchorEl={anchorElMenu}
             anchorOrigin={{
               vertical: 'bottom',
               horizontal: 'left',
             }}
             keepMounted
             transformOrigin={{
               vertical: 'top',
               horizontal: 'left',
             }}
             open={Boolean(anchorElMenu)}
             onClose={handleCloseMenu}
             onClick={handleCloseMenu}
             sx={{ display: { xs: 'block' } }}
             slotProps = {{
               paper: {
                 style: {
                   maxHeight: 4.5*ITEM_HEIGHT
                 }
               }
             }}
            >
              <MenuItem onClick={handleCloseMenu}>
                <ListItemIcon>
                  <Person/>
                </ListItemIcon>
                Profile
              </MenuItem>

              <Divider />

              <MenuItem onClick={handleCloseMenu}>
                <ListItemIcon>
                  <Settings/>
                </ListItemIcon>
                Settings
              </MenuItem>

              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout/>
                </ListItemIcon>
                Logout
              </MenuItem>


            </Menu>

           <IconButton
             size="large"
             edge="start"
             color="inherit"
           >
             <MenuIcon />
           </IconButton>

         </Box>

     </Toolbar>
);
};
